/* eslint-disable react/no-unknown-property */
import React from 'react';
import {
  ActionIcon,
  ActionIconProps,
  Card,
  FontWeight,
  HStack,
  ICON_FOLDER_OUTLINE,
  Text,
} from '@doveit/bricks';
import { formatDate } from '@doveit/hammer';
import * as styles from './CanvaCard.style';
import CanvaDesignPreview from '../canva-design-preview/CanvaDesignPreview';
import { CANVA_CARD_ASPECT_RATIO } from '../../constants';

export type CanvaCardType = 'folder' | 'template' | 'design';

export interface CanvaCardProps {
  title: string,
  date?: string,
  dateLabel?: string,
  type: 'folder' | 'template' | 'design',
  thumbnailUrl?: string,
  primaryAction: React.ReactNode,
  secondaryAction?: Pick<ActionIconProps, 'icon' | 'label' | 'onClick'>,
}

export const mapTypeToBadgeLabel: Record<CanvaCardType, string> = {
  folder: 'Cartella',
  template: 'Template',
  design: 'Progetto',
};

const CanvaCard: React.FC<CanvaCardProps> = ({
  title,
  date,
  dateLabel,
  type,
  thumbnailUrl,
  primaryAction,
  secondaryAction,
}) => {
  const isFolder = React.useMemo(
    () => type === 'folder',
    [type],
  );

  return (
    <Card highlighted={isFolder}>
      <CanvaDesignPreview
        aspectRatio={CANVA_CARD_ASPECT_RATIO}
        src={thumbnailUrl}
        alt={title}
        color={isFolder ? 'primary' : 'neutral'}
        iconPlaceholder={isFolder ? ICON_FOLDER_OUTLINE : undefined}
        badgeLabel={mapTypeToBadgeLabel[type]}
      />
      <Card.Content>
        <div css={styles.info}>
          <p css={styles.titleWrapper}>{title}</p>
          {date && (
            <Text.Caption fontWeight={FontWeight.LIGHT}>{dateLabel} {formatDate(new Date(date))}</Text.Caption>
          )}
        </div>
        <HStack justifyContent="space-between" gap={75}>
          <div css={styles.primaryActionWrapper}>
            {primaryAction}
          </div>
          {secondaryAction && (
            <ActionIcon
              icon={secondaryAction.icon}
              label={secondaryAction.label}
              size="S"
              onClick={secondaryAction.onClick}
              aria-label={secondaryAction.label}
            />
          )}
        </HStack>
      </Card.Content>
    </Card>
  );
};

export default CanvaCard;
